import React, { useRef } from 'react';
import PropTypes from 'prop-types';
import isEmpty from 'lodash/isEmpty';
import ComponentErrorBoundary from 'core/modules/ErrorBoundaries/ComponentErrorBoundary';
import { ShowOnMQ } from 'core/modules/MediaQueries/MediaQueries';
import RelatedStores from 'core/modules/RelatedStores/RelatedStores';

import ContentWrap from 'core/modules/Partials/ContentWrap/ContentWrap';
import StickyMenu from 'core/modules/Partials/StickyMenu/StickyMenu';
import DntMobileWarning from 'core/modules/DntMobileWarning/DntMobileWarning';

import MerchantInfoStickyTile from '../../MerchantInfoStickyTile/MerchantInfoStickyTile';
import MerchantInfoTile from '../../MerchantInfoTile/MerchantInfoTile';
import MerchantOffers from '../../MerchantOffers/MerchantOffers';
import MerchantDescription from '../../MerchantDescription/MerchantDescription';
import MerchantPageTitle from '../../MerchantPageTitle/MerchantPageTitle';
import MerchantEarningCategories from '../../MerchantEarningCategories/MerchantEarningCategories';
import MerchantBonusOffer from '../../MerchantBonusOffer/MerchantBonusOffer';

import {
  MERCHANT_EXPERIENCE_TYPE_SINGLE, MERCHANT_EXPERIENCE_TYPE_DIRECT_LINK,
} from '../../../actions/types';

function MerchantExperienceViewSingle({
  merchant, config, children, keywords,
}) {
  const {
    tiers, offers, flags = {}, name,
  } = merchant || {};
  const { getDntMobileWarningText } = config || {};
  const descriptionRef = useRef();
  const shouldShowDntMobileWarning = !flags.tracksMobile;

  const getClassNames = () => (
    `mn_merchantExperienceSingleMerchant ${isEmpty(offers) ? 'mn_withoutOffers' : '' }`
  );
  const getPageType = () => (
    keywords ? MERCHANT_EXPERIENCE_TYPE_SINGLE : MERCHANT_EXPERIENCE_TYPE_DIRECT_LINK
  );

  const classNames = getClassNames();
  const pageType = getPageType();

  return (
    <div className={classNames} data-test="merchant-experience-single" data-page-type={pageType}>
      <ContentWrap>
        <ShowOnMQ mobile>
          <StickyMenu bottomOffset="top" wrapperRef={descriptionRef} shouldShowNonStickyMenu={false}>
            <MerchantInfoStickyTile merchant={merchant} config={config} />
          </StickyMenu>
        </ShowOnMQ>
        <DntMobileWarning
          shouldShowDntMobileWarning={shouldShowDntMobileWarning}
          getText={getDntMobileWarningText}
          name={name}
        />
        <MerchantInfoTile merchant={merchant} config={config} descriptionRef={descriptionRef} />
        <MerchantPageTitle merchant={merchant} config={config} />
        <MerchantEarningCategories tiers={tiers} />
        <MerchantBonusOffer />
        <MerchantOffers offers={offers} />
        <MerchantDescription merchant={merchant} config={config} ref={descriptionRef} />
        {children}
        {keywords && <RelatedStores merchantIds={[merchant.id]} />}
      </ContentWrap>
    </div>
  );
}

MerchantExperienceViewSingle.propTypes = {
  merchant: PropTypes.shape({}).isRequired,
  config: PropTypes.shape({}),
  keywords: PropTypes.string,
  children: PropTypes.oneOfType([
    PropTypes.node,
    PropTypes.arrayOf(PropTypes.node),
  ]),
};

MerchantExperienceViewSingle.defaultProps = {
  config: {},
  keywords: null,
  children: null,
};

export default (props) =>
  <ComponentErrorBoundary><MerchantExperienceViewSingle {...props} /></ComponentErrorBoundary>;
